import d, { createElement as H } from "react";
import e from "prop-types";
import $ from "classnames";
import s from "./index738.mjs";
import { TYPOGRAPHY_TEXT_ALIGN as n, TYPOGRAPHY_TEXT_TRANSFORM as A, TYPOGRAPHY_WEIGHTS as P, TYPOGRAPHY_RENDER_AS as l, TYPOGRAPHY_SIZES as o, TYPOGRAPHY_BASE_CLASS as a } from "./index46.mjs";
const T = ({
  as: t,
  children: r,
  classes: i,
  color: Y,
  margin: _ = "0 0 8px 0",
  size: m,
  style: c,
  textAlign: g,
  textTransform: E,
  weight: f,
  ellipsis: S,
  dataQA: G
}) => H(
  t,
  {
    className: $([
      s[a],
      s[`${a}--${f}`],
      s[`${a}--${m}`],
      s[`${a}--${Y}`],
      s[`${a}--${E}`],
      s[`${a}--text-align-${g}`],
      S && s[`${a}--ellipsis`],
      i
    ]),
    style: { ...c, margin: _ },
    "data-qa": G
  },
  r
), O = {
  textAlign: e.oneOf(Object.values(n)),
  textTransform: e.oneOf(Object.values(A)),
  children: e.oneOfType([
    e.element,
    e.string,
    e.node
  ]).isRequired,
  weight: e.oneOf(Object.values(P)),
  classes: e.string,
  style: e.object,
  color: e.string,
  margin: e.string,
  dataQA: e.string,
  ellipsis: e.bool
}, p = {
  textAlign: n.START,
  textTransform: A.NONE,
  weight: P.REGULAR,
  classes: "",
  style: {},
  color: void 0,
  margin: "0 0 8px 0",
  dataQA: "",
  ellipsis: !1
};
T.propTypes = {
  ...O,
  as: e.oneOf(Object.values(l))
};
T.defaultProps = {
  ...p,
  as: l.SPAN
};
const R = ({
  children: t,
  size: r = o[0],
  ...i
}) => /* @__PURE__ */ d.createElement(T, { ...i, size: r, as: l.P }, t);
R.propTypes = {
  ...O,
  size: e.oneOf(Object.values(o))
};
R.defaultProps = {
  ...p,
  size: o[0]
};
export {
  R as Paragraph,
  a as TYPOGRAPHY_BASE_CLASS,
  l as TYPOGRAPHY_RENDER_AS,
  o as TYPOGRAPHY_SIZES,
  n as TYPOGRAPHY_TEXT_ALIGN,
  A as TYPOGRAPHY_TEXT_TRANSFORM,
  P as TYPOGRAPHY_WEIGHTS,
  T as Typography,
  T as default
};
